import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Mail, Send } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const AdvisorEmailSettings = ({ reportId, reportReady }) => {
  const [recips, setRecips] = useState('');
  const [enabled, setEnabled] = useState(true);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/advisor/email-settings`, { headers: hdr() })
      .then((r) => { setRecips(r.data.recipients.join(', ')); setEnabled(r.data.enabled); }).catch(() => {});
  }, []);

  const save = async (nextEnabled = enabled) => {
    try {
      const r = await axios.put(`${API_URL}/api/advisor/email-settings`, {
        recipients: recips.split(',').map((s) => s.trim()).filter(Boolean), enabled: nextEnabled,
      }, { headers: hdr() });
      setRecips(r.data.recipients.join(', ')); setEnabled(r.data.enabled); toast.success('Email settings saved');
    } catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); }
  };
  const sendNow = async () => {
    setSending(true);
    try { const r = await axios.post(`${API_URL}/api/advisor/report/${reportId}/email`, {}, { headers: hdr() }); toast.success(`Report emailed to ${r.data.sent_to} recipient(s)`); }
    catch (e) { toast.error(e.response?.data?.detail || 'Email failed'); }
    finally { setSending(false); }
  };

  return (
    <div className="rounded-lg border border-slate-300 bg-white p-3 flex flex-wrap items-center gap-3 text-sm text-slate-800" data-testid="advisor-email-settings">
      <Mail className="h-4 w-4 text-amber-600" />
      <label className="flex items-center gap-2 font-semibold">
        <input type="checkbox" checked={enabled} onChange={(e) => { setEnabled(e.target.checked); save(e.target.checked); }} data-testid="advisor-email-enabled" />
        Email a fresh report on the 7th of every month (7am) to
      </label>
      <Input value={recips} onChange={(e) => setRecips(e.target.value)} placeholder="email@example.com, another@example.com" className="flex-1 min-w-[220px] h-8" data-testid="advisor-email-recipients" />
      <Button size="sm" variant="outline" onClick={() => save()} data-testid="advisor-email-save">Save</Button>
      <Button size="sm" onClick={sendNow} disabled={!reportReady || sending} className="bg-amber-500 hover:bg-amber-400 text-slate-900" data-testid="advisor-email-send-now">
        <Send className="h-3.5 w-3.5 mr-1" />{sending ? 'Sending…' : 'Email this report now'}
      </Button>
    </div>
  );
};
